module.exports = "/static/media/close.15245cc1.svg";


//////////////////
// WEBPACK FOOTER
// ../public/images/close.svg
// module id = 555
// module chunks = 0